const testimonials = [
  {
    name: "Jim and Linda P.",
    role: "Cape Coral Canal-Front Homeowners",
    highlight: "Bahamas fishing charter in 3 days — water-damaged passport",
    story:
      "We live on a canal in Cape Coral and keep our boat docked behind the house. We booked a three-day Bahamas fishing charter out of West Palm that we had been planning for six months. The morning before departure, I pulled my passport from the safe and the binding had completely separated — humidity from the canal air had gotten to it over the years. The charter company said no passport, no boarding, and the deposit was $3,800 non-refundable. I called Fast Passport Center in desperation. They walked me through getting a new photo at the Walgreens on Cape Coral Parkway, arranged a same-day acceptance appointment in Fort Myers, and had my emergency application processed and shipped overnight. I had my new passport in 36 hours and made the charter. We caught three mahi-mahi and a wahoo. I will never store my passport in that safe again.",
    rating: 5,
    tag: "Emergency",
  },
  {
    name: "The Martinez Family",
    role: "Year-Round Cape Coral Residents",
    highlight: "Spring break Cancun trip — child's passport expired",
    story:
      "We booked an all-inclusive in Cancun for our two kids' spring break through Allegiant from Punta Gorda. We booked in October when the flights went on sale — $189 round trip, we could not pass it up. Fast forward to February, and my wife asked if the kids' passports were still good. Our daughter's was fine, but our son's had expired the previous summer — he was 8 when it was issued, so it was only good for 5 years. We had no idea. We were six weeks from departure and thought we were in trouble. Fast Passport Center handled the child passport renewal with the parental consent forms, the in-person appearance requirements, and everything else we did not understand. Our son had his new passport in 10 days. The Cancun trip was amazing — the kids swam with dolphins and we made memories that will last forever. We now check all four passports every September like clockwork.",
    rating: 5,
    tag: "Child Passport",
  },
  {
    name: "Robert H.",
    role: "Snowbird from Toronto, Winter Resident in Cape Coral",
    highlight: "European river cruise — Schengen validity rule surprise",
    story:
      "My wife and I have been wintering in Cape Coral for 12 years. We bought a canal-front home in the northwest section and spend November through April here every year. This past fall, we booked a Rhine River cruise for May — Amsterdam to Basel, the whole thing. We paid in full in December to get the early booking discount. In March, I checked my passport and saw it expired in June — after the cruise ended. I figured I was fine since it was still valid during the trip. Wrong. The Schengen rule requires three months of validity beyond your departure date, and the cruise line flagged it when we submitted our documents. We were three weeks from departure and facing the loss of a $14,000 cruise. Fast Passport Center processed an expedited renewal and had it back to our Cape Coral address in 6 business days. We made the cruise, saw castles along the Rhine, and drank Riesling in Rudesheim. I had no idea about the three-month rule. Now I know — and so does every snowbird at our community potluck.",
    rating: 5,
    tag: "Luxury Travel",
  },
];

export default function CapeCoralTestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Cape Coral Client Stories
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Cape Coral Travelers Say About Us
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 md:p-8 border border-gray-100 shadow-sm hover:shadow-md transition-all"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>

              <div className="inline-block bg-[#F6C344]/10 text-[#1A365D] text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full mb-4">
                {t.tag}
              </div>

              <p className="text-gray-600 text-sm leading-relaxed mb-6 italic">
                &ldquo;{t.story}&rdquo;
              </p>

              <div className="border-t border-gray-100 pt-4">
                <div className="font-semibold text-[#1A365D] text-sm">{t.name}</div>
                <div className="text-gray-500 text-xs">{t.role}</div>
              </div>

              <div className="mt-3 bg-[#1A365D]/5 rounded-md px-3 py-2">
                <p className="text-[#1A365D] text-xs font-semibold">{t.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}